import React from 'react';

const partners = [
  { name: 'Metricon', logo: 'https://static.wixstatic.com/media/eaf73e_3949735b6c074544bffdec3302a0e9da~mv2.webp' },
  { name: 'Simonds', logo: 'https://static.wixstatic.com/media/eaf73e_e8d3aeec56b1438bb7c5c630bbf02b30~mv2.webp' },
  { name: 'Fairmont Homes', logo: 'https://static.wixstatic.com/media/eaf73e_eca99e7d75c640159e13ada49dff36b8~mv2.png' },
  { name: 'ABC Homes', logo: 'https://static.wixstatic.com/media/eaf73e_78a0128385cb4ee99a6ae92122ceba34~mv2.webp' },
  { name: 'Rossdale Homes', logo: 'https://static.wixstatic.com/media/eaf73e_9a03c8f5eba04157a0bde0cd71fe7eba~mv2.webp' },
  { name: 'Lofty Building Group', logo: 'https://static.wixstatic.com/media/eaf73e_689a8ec901314d6bac4c4fd0350eafab~mv2.webp' },
  { name: 'Scott Salisbury Homes', logo: 'https://static.wixstatic.com/media/eaf73e_fd3baf74e5914046a0c2e9634755877f~mv2.webp' },
  { name: 'Alete Homes', logo: 'https://static.wixstatic.com/media/eaf73e_8315640104624e0184cbf5cdb82d7d7a~mv2.webp' },
  { name: 'Homesolution by Metricon', logo: 'https://static.wixstatic.com/media/eaf73e_18701c175d5c4eb0a8d2509a32853443~mv2.webp' },
  { name: 'Belroc Homes', logo: 'https://static.wixstatic.com/media/eaf73e_cc1e31011a2a48ffa27b21fdccd45931~mv2.webp' },
  { name: 'Regent Homes', logo: 'https://static.wixstatic.com/media/eaf73e_5495c07c813d4efcb3ce5d96e8074f63~mv2.webp' },
  { name: 'Format Homes', logo: 'https://static.wixstatic.com/media/eaf73e_5145878a84d1475685a91e827e52e017~mv2.webp' },
  { name: 'Bradford Homes', logo: 'https://static.wixstatic.com/media/eaf73e_a8a78c278aea4d3ab5a3ea3b14cf289a~mv2.webp' },
  { name: 'Homecorp', logo: 'https://static.wixstatic.com/media/eaf73e_0631820f898f4d07a695a90483664466~mv2.webp' },
  { name: 'Property Complete', logo: 'https://static.wixstatic.com/media/eaf73e_5a7187f98ed749e48625e64e910aaf39~mv2.webp' },
  { name: 'Buildscope', logo: 'https://static.wixstatic.com/media/eaf73e_68bd725029624cb39864b4eb5262f004~mv2.jpg' },
  { name: 'Kentbuilt', logo: 'https://static.wixstatic.com/media/eaf73e_276a7ce761574a8f84e41ed04c14c97b~mv2.jpg' },
  { name: 'Lavida Homes', logo: 'https://static.wixstatic.com/media/eaf73e_84f33ca21b9442c68dfe44640959f922~mv2.png' },
  { name: 'ST Construct', logo: 'https://static.wixstatic.com/media/eaf73e_4694b91c13e74b8d9359e1c39115c2a6~mv2.png' },
  { name: 'LS Design & Construct', logo: 'https://static.wixstatic.com/media/eaf73e_0e9a841d565244b58228f8e7b2521cc3~mv2.webp' },
  { name: 'Hot Property Group', logo: 'https://static.wixstatic.com/media/eaf73e_5d44abc47082435cb91211f831a5cd96~mv2.webp' },
  { name: 'Urban3', logo: 'https://static.wixstatic.com/media/eaf73e_62818d7c8da74ce68233c5f54137f11b~mv2.png' },
  { name: 'AP Designer Homes', logo: 'https://static.wixstatic.com/media/eaf73e_5e561459b3854850b29145a3c250334b~mv2.png' },
  { name: 'Urban Edge SA', logo: 'https://static.wixstatic.com/media/eaf73e_eab1579c1f8e412cadd8ff7f1078bd92~mv2.png' },
  { name: 'Double A Homes', logo: 'https://static.wixstatic.com/media/eaf73e_8b134b8bb9e9401da1bdf0d2049ddadf~mv2.png' },
  { name: 'Orne Homes', logo: 'https://static.wixstatic.com/media/eaf73e_f5f23681cbb6449b88b978348841ecc3~mv2.png' },
];

// Split partners into 3 rows
const row1Partners = partners.slice(0, 9);
const row2Partners = partners.slice(9, 18);
const row3Partners = partners.slice(18, 26);

const MarqueeRow = ({ items, direction = 'left', speed = 30 }) => {
  const duplicatedItems = [...items, ...items, ...items, ...items];
  
  return (
    <div className="relative overflow-hidden py-2">
      <div 
        className={`flex gap-12 sm:gap-16 ${direction === 'left' ? 'animate-marquee-left' : 'animate-marquee-right'}`}
        style={{ 
          width: 'max-content',
          animationDuration: `${speed}s`
        }}
      >
        {duplicatedItems.map((partner, index) => (
          <div 
            key={`${partner.name}-${index}`}
            className="flex-shrink-0 w-[100px] sm:w-[120px] h-[45px] sm:h-[55px] flex items-center justify-center"
          >
            <img 
              src={partner.logo}
              alt={`${partner.name} - BuildPilot Partner`}
              className="max-h-full max-w-full object-contain grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all duration-300"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

const PartnerLogosSection = () => {
  return (
    <section className="py-6 sm:py-8 pb-12 sm:pb-16 bg-white overflow-hidden" data-testid="partner-logos-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-6">
        <h2 className="font-serif text-2xl sm:text-3xl text-gray-900 text-center">
          <span className="gradient-text">Trusted</span> by Australia's Leading Builders
        </h2>
      </div>
      
      {/* 3 Rows of scrolling logos */}
      <div className="space-y-2">
        <MarqueeRow items={row1Partners} direction="left" speed={35} />
        <MarqueeRow items={row2Partners} direction="right" speed={40} />
        <MarqueeRow items={row3Partners} direction="left" speed={32} />
      </div>
    </section>
  );
};

export default PartnerLogosSection;
